export const LoadingState = () => {
  const childClassName = 'h-6 bg-skeleton rounded-md w-full'

  return (
    <div className="animate-pulse flex space-s-4 mt-3">
      <div className="space-y-3 flex-1">
        <div className={childClassName} />
        <div className={childClassName} />
        <div className={childClassName} />
        <div className={childClassName} />
        <div className={childClassName} />
      </div>
    </div>
  )
}
